import React from 'react';
import { Link } from 'react-router-dom';

function TherapistJoinSection() {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-[#254e70] to-[#1d3e5a] text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#9dacff]/20 text-[#9dacff] px-4 py-2 rounded-full text-sm font-medium mb-6">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              For Licensed Therapists
            </div>
            
            <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-[#e4fde1]">
              Grow Your Practice with
              <br />
              <span className="text-[#9dacff]">Qualified Client Leads</span>
            </h2>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Stop spending time on marketing. Join therapists who get discovered by clients searching for their exact specializations and treatment approaches.
            </p>

            {/* Benefits */}
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-[#9dacff] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-white/90">Get found by ideal clients searching for your specialties</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-[#9dacff] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-white/90">Free to join • 10-minute setup • No contracts</span>
              </div>
                             <div className="flex items-center gap-3">
                 <div className="w-6 h-6 bg-[#9dacff] rounded-full flex items-center justify-center flex-shrink-0">
                   <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                     <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                   </svg>
                 </div>
                 <span className="text-white/90">Connect directly with pre-qualified clients</span>
               </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/join"
                className="group inline-flex items-center justify-center gap-3 bg-[#9dacff] text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-white hover:text-[#9dacff] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
              >
                Join for Free
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <Link 
                to="/for-therapists"
                className="inline-flex items-center justify-center gap-3 bg-white/10 text-white px-8 py-4 rounded-2xl font-semibold hover:bg-white/20 transition-all duration-300 border border-white/30"
              >
                Learn More
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Right side - Visual/Stats */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              {/* Testimonial */}
              <div className="bg-white/10 rounded-2xl p-6 border border-white/20">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img 
                      src="https://counselingunconditionally.com/wp-content/uploads/2025/02/Courtney-Headshot-4-1.jpg"
                      alt="Courtney Morgan"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-white font-semibold">Courtney Morgan</div>
                    <div className="text-white/70 text-sm">LPCC-S, Co-Founder</div>
                  </div>
                </div>
                <p className="text-white/90 text-sm italic">
                  "I wanted to create the resource I wish had existed when I was starting my practice—and the one I wish my clients had when they were looking for help."
                </p>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -inset-4 bg-gradient-to-br from-[#9dacff]/20 to-transparent rounded-3xl -z-10 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TherapistJoinSection; 